import { render, staticRenderFns } from "./fyt.vue?vue&type=template&id=5074fc46&"
import script from "./fyt.vue?vue&type=script&lang=js&"
export * from "./fyt.vue?vue&type=script&lang=js&"
import style0 from "./fyt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports